import React from "react";

const sportsFacultyData = {
  columns: ["Role", "Name", "Qualification", "Experience"],
  rows: [
    ["Physical Education Director", "Shri. G. S. Yallur", "M.P.Ed, K-SET", "Fifteen Years"],
    ["Supporting Staff", "Mr. Fakerappa I T", "S.S.L.C", "Seven Years"],
  ],
};

const SportsFaculty = ({ section }) => {
  const facultyData = section || sportsFacultyData;

  return <ResponsiveTable columns={facultyData.columns} rows={facultyData.rows} />;
};

const ResponsiveTable = ({ columns, rows }) => (
  <div className="overflow-x-auto bg-white border border-brand/15">
    <table className="min-w-[640px] sm:min-w-full text-sm text-left">
      <thead className="bg-brand text-surface">
        <tr>
          {columns.map((column) => (
            <th key={column} className="px-4 py-3 font-semibold whitespace-nowrap">
              {column}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, rowIndex) => (
          <tr key={`${row.join("-")}-${rowIndex}`} className="border-t border-brand/10">
            {row.map((cell, cellIndex) => (
              <td key={`${cell}-${cellIndex}`} className="px-4 py-3 align-top text-[#2a2a2a]">
                {cell}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default SportsFaculty;
